<template>
  <div class="scene-mall-mobile" :class="classList">

    <MapObject class="scene-mall-mobile__mall" src="/map/mall.png" :animated="ready" type="building"></MapObject>
    <MapObject class="scene-mall-mobile__parking" src="/map/mobile_mall_parking.png" :animated="ready" type="trees"></MapObject>
    <MapObject class="scene-mall-mobile__trees" src="/map/mobile_mall_trees.png" :animated="ready" type="trees"></MapObject>

    <MapObject class="scene-mall-mobile__b1" src="/map/build_6f.png" :animated="ready" type="building"></MapObject>
    <MapObject class="scene-mall-mobile__b2" src="/map/build_6f.png" :animated="ready" type="building"></MapObject>
    <MapObject class="scene-mall-mobile__b3" src="/map/build_14f.png" :animated="ready" type="building"></MapObject>
    <MapObject class="scene-mall-mobile__b4" src="/map/build_8f_1.png" :animated="ready" type="building"></MapObject>
    <MapObject class="scene-mall-mobile__b5" src="/map/build_8f_1.png" :animated="ready" type="building"></MapObject>
    <MapObject class="scene-mall-mobile__b6" src="/map/build_2f_1.png" :animated="ready" type="building"></MapObject>
    <MapObject class="scene-mall-mobile__b7" src="/map/build_2f_1.png" :animated="ready" type="building"></MapObject>
    <MapObject class="scene-mall-mobile__b8" src="/map/build_8f_2.png" :animated="ready" type="building"></MapObject>
    <MapObject class="scene-mall-mobile__b9" src="/map/build_8f_2.png" :animated="ready" type="building"></MapObject>
    <MapObject class="scene-mall-mobile__b10" src="/map/build_4f_long_2.png" :animated="ready" type="building"></MapObject>

  </div>
</template>

<script>
  import Scene from './Scene.vue'

  export default {
    extends: Scene,
  }
</script>

<style lang="scss">
  .scene-mall-mobile {
    @include relative-units(401.44px, 409.21px, mobile)
  }

  .scene-mall-mobile__mall {
    left: 38%;
    top: 24.9%;
    width: 48%;
  }

  .scene-mall-mobile__trees{
    left: -0.5%;
    top: 0;
    width: 83.5%;
  }

  .scene-mall-mobile__parking {
    left: 58.4%;
    top: 59%;
    width: 35%;
  }
  .scene-mall-mobile__b1 {
    left: 26.6%;
    top: 0.2%;
    width: 11%;
  }
  .scene-mall-mobile__b2 {
    left: 17%;
    top: 5.6%;
    width: 11%;
  }
  .scene-mall-mobile__b3 {
    left: 5.6%;
    top: 2.4%;
    width: 11.8%;
  }
  .scene-mall-mobile__b4 {
    left: 10.7%;
    top: 57.5%;
    width: 11.3%;
  }
  .scene-mall-mobile__b5 {
    left: 1%;
    top: 63%;
    width: 11.3%
  }
  .scene-mall-mobile__b6 {
    left: 49.5%;
    top: 75%;
    width: 14%;
  }
  .scene-mall-mobile__b7 {
    left: 39%;
    top: 82%;
    width: 14%;
  }
  .scene-mall-mobile__b8 {
    left: 78.8%;
    top: 7.7%;
    width: 12%;
  }
  .scene-mall-mobile__b9 {
    left: 69%;
    top: 13.4%;
    width: 12%;
  }
  .scene-mall-mobile__b10 {
    left: 81%;
    top: 19.8%;
    width: 19%;
  }
</style>
